export const STATUSES = ['New','Contacted','Follow-up','Call Booked','Proposal Sent','Negotiating','Won','Retainer','Lost'];
export const ICP_TYPES = ['ICP-1 International','ICP-2 India SMB'];
export const OUTREACH_TYPES = ['LinkedIn','Email','WhatsApp','Call'];
export const OUTREACH_STATUSES = ['Drafted','Sent','Replied','No Response'];
export const KB_CATEGORIES = ['lead-research','outreach-templates','sops','proposals'];
export const SCORE_THRESHOLDS = { hot: 70, warm: 40 };
export const ASSIGNEES = ['Nayema','Divyanshu'];
